import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        await http.post("/auth/google/session", { session_id: sessionId }, { withCredentials: true });
        await checkAuth();
        window.location.href = "/app";
      } catch (e) {
        console.error("Auth exchange failed", e);
        nav("/login?error=1");
      }
    })();
  }, [nav, checkAuth]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center">
      <div className="text-center">
        <div className="overline mb-3">Establishing War Room</div>
        <div className="h-1 w-64 mm-scan-bar" />
      </div>
    </div>
  );
}
